import User from './User';
import React from 'react';


const OK = 200
const NOT_AUTHORIZED = 401

const TITLES_AFTER_LAST_NAME = [
    "BSeng",
    "MSeng",
    "BSc",
    "MSc",
    "IWE",
    "PMSE"
]

const STATES = [
    "Aspirant",
    "Register constructeur",
    "Register ontwerper",
    "RT a",
    "RT b",
    "Afgewezen",
    "Nonactief"
]

const TITLES_FOR_LAST_NAME = [
    "dr.",
    "drs.",
    "ing.",
    "ir.",
    "ir. drs.",
    "ir. ing.",
    "mr.",
    "prof.",
    "prof. ir."
]

const WORK_AREAS = [
    "Staal",
    "Beton",
    "Hout",
    "Overig",
    "Utiliteitsbouw",
    "Industriebouw",
    "Infra/kunstwerken",
    "Funderingstechniek",
    "Hoogbouw",
    "Offshore",
    "Natte waterbouw",
    "Woningbouw"
]

const MANAGE_ACCESS = [
    //"Opleidingen",
    "Permanente educatie",
    //"Werkervaring",
    "Doorlopende werkervaring"]

const MEMBER_PERMISSIONS = [
    "Doorzoekbaar maken van bedrijf",
    "De nieuwsbrief"
]

const EDUCATION_OPTIONS = [
    "Geeft diploma uit",
    "In keuzelijst Mijn CR",
    "Zichtbaar op website"
]

const COMMUNICATION_OPTIONS = [
    "Publiceren",
    "Zichtbaar op homepage",
    "Bovenaan houden"
]

const ACCOUNT_ROLES = [
    "Admin",
    "Secretariaat beheer",
    "Secretariaat bekijken"
]

const printActivated = false

class Api {
    constructor() {
        //this.Url = 'https://crtestapi.wefo020.e-f.nl/'
        //this.Url = 'http://localhost:5000/'
        this.Url = 'https://constructor.wefo020.e-f.nl/'
        this.PostApi = this.PostApi.bind(this)
        this.GetApi = this.GetApi.bind(this)
        this.GetApiDownload = this.GetApiDownload.bind(this)
        this.PostTableApi = this.PostTableApi.bind(this)
        this.GetTableApi = this.GetTableApi.bind(this)
    }

    showError = (errors, name) => {
        const errorCamelCase = errors[name]
        const errorLowerCase = errors[name.toLowerCase()]

        if (errorCamelCase) return <p style={{ color: 'red' }}>Dit veld is incorrect ingevuld</p>
        if (errorLowerCase) return <p style={{ color: 'red' }}>Dit veld is incorrect ingevuld</p>
        return null
    }
    toCSV(obj, separator) {
        var arr = [];

        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (obj[key] === true) {
                    arr.push(key);
                }
            }
        }

        return arr.join(separator || ",");
    }
    formatDate(date) {
        //return date === null ? "" : new Date(date).toLocaleDateString("nl-NL");
        return date === null ? "" : new Date(date).getFullYear() == 1970 ? "" : new Date(date).toLocaleDateString("nl-NL");
    }
    formatDateAndTime(date) {
        //return date === null ? "" : new Date(date).toLocaleDateString("nl-NL") + ' ' + new Date(date).toLocaleTimeString("nl-NL")

        return date === null ? "" : new Date(date).getFullYear() == 1970 ? "" : new Date(date).toLocaleDateString("nl-NL") + ' ' + new Date(date).toLocaleTimeString("nl-NL")
    }

    print(text) {
        if (printActivated)
            console.log(text)
    }

    getTitlesAfterLastName = () => TITLES_AFTER_LAST_NAME
    getStates = () => STATES
    getTitlesForLastName = () => TITLES_FOR_LAST_NAME
    getWorkAreas = () => WORK_AREAS
    getManageAccess = () => MANAGE_ACCESS
    getMemberPermissions = () => MEMBER_PERMISSIONS
    getEducationOptions = () => EDUCATION_OPTIONS
    getCommunicationOptions = () => COMMUNICATION_OPTIONS
    getAccountRoles = () => ACCOUNT_ROLES

    GetApi(FETCH_URL) {
        if (User.isLoggedIn()) {
            return fetch(this.Url + FETCH_URL, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + User.getToken(),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'same-origin'
            }
            ).then(response => {
                this.print("GET API Response (user logged in)")
                this.print("----------")
                return response.json()
            }).catch(e => {
                this.print('Request failed', e)
                return undefined
            })
        } else {
            return fetch(this.Url + FETCH_URL, {
                method: 'GET',
            }
            ).then(response => {
                this.print("GET API Response (user not logged in)")
                this.print(response)
                this.print("----------")
                return response.json()
            }).catch(e => {
                this.print('Request failed', e)
                return undefined
            })
        }

    }

    GetApiDownload(FETCH_URL) {
        if (User.isLoggedIn()) {
            return fetch(this.Url + FETCH_URL, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + User.getToken(),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'same-origin'
            }
            ).then(response => {
                this.print("GET API Response (user logged in)")
                // //Create a Blob from the PDF Stream
                // const file = new Blob(
                //     [response.url], 
                //     {type: 'application/pdf'});
                // //Build a URL from the file
                const fileURL = response.url;
                // //Open the URL on new Winow
                window.open(fileURL);
            }).catch(e => {
                this.print('Request failed', e)
                return undefined
            })
        } else {
            return fetch(this.Url + FETCH_URL, {
                method: 'GET',
            }
            ).then(response => {
                window.open(response);
            }).catch(e => {
                this.print('Request failed', e)
                return undefined
            })
        }

    }
    PostApiDownloadFile(FETCH_URL, data, nav) {
        return fetch(this.Url + FETCH_URL, {
            method: 'POST',
            headers:
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + User.getToken()
            },
            body: JSON.stringify(data)
        }).then(response => {
            return response.blob()
        }).catch(e => {
            this.print('Request failed', e)
            return undefined
        })
    }
    PostApi(FETCH_URL, data, nav) {
        if (User.isLoggedIn()) {
            return fetch(this.Url + FETCH_URL, {
                method: 'POST',
                headers:
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + User.getToken()
                },
                body: JSON.stringify(data)
            }).then(response => {
                this.print("Post API Response (user logged in)")
                this.print(response)
                this.print("----------")
                if (response.status === NOT_AUTHORIZED) nav.push("/account")
                else if (response.status === OK) return response.json()
                else return response.json()
            }).catch(e => {
                this.print('Request failed', e)
                return undefined
            })
        } else {
            return fetch(this.Url + FETCH_URL, {
                method: 'POST',
                headers:
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            }).then(response => {
                this.print("Post API Response (user not logged in)")
                this.print(response)
                this.print("----------")

                if (response.status === NOT_AUTHORIZED) nav.push("/account")
                else if (response.status === OK) return response.json()
                else return response.json()
            }).catch(e => {
                this.print('Request failed', e)
                return undefined
            })
        }
    }

    PostApiWithoutThen(FETCH_URL, data, nav) {
        if (User.isLoggedIn()) {
            return fetch(this.Url + FETCH_URL, {
                method: 'POST',
                headers:
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + User.getToken()
                },
                body: JSON.stringify(data)
            })
        } else {
            return fetch(this.Url + FETCH_URL, {
                method: 'POST',
                headers:
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            })
        }
    }

    PostApiWithoutBody(FETCH_URL, nav) {
        if (User.isLoggedIn()) {
            return fetch(this.Url + FETCH_URL, {
                method: 'POST',
                headers:
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + User.getToken()
                }
            }).then(response => {
                this.print("Post API Response (user logged in)")
                this.print(response)
                this.print("----------")

                if (response.status === NOT_AUTHORIZED) nav.push("/account")
                else if (response.status === OK) return undefined
                else return response.json()
            }).catch(e => {
                this.print('Request failed', e)
                return undefined
            })
        } else {
            return fetch(this.Url + FETCH_URL, {
                method: 'POST',
                headers:
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }).then(response => {
                this.print("Post API Response (user not logged in)")
                this.print(response)
                this.print("----------")

                if (response.status === NOT_AUTHORIZED) nav.push("/account")
                else if (response.status === OK) return undefined
                else return response.json()
            }).catch(e => {
                this.print('Request failed', e)
                return undefined
            })
        }
    }

    PostApiWithFile(FETCH_URL, data, nav) {
        if (User.isLoggedIn()) {
            return fetch(this.Url + FETCH_URL, {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + User.getToken()
                },
                body: data
            }).then(response => {
                this.print("Post API Response (user logged in)")
                this.print(response)
                this.print("----------")
                if (response.status === NOT_AUTHORIZED) nav.push("/account")
                else if (response.status === OK) return undefined
                else return response.json()
            }).catch(e => {
                return undefined
            })
        } else {
            return fetch(this.Url + FETCH_URL, {
                method: 'POST',
                body: data
            }).then(response => {
                this.print("Post API Response (user not logged in)")
                this.print(response)
                this.print("----------")

                if (response.status === NOT_AUTHORIZED) nav.push("/account")
                else if (response.status === OK) return undefined
                else return response.json()
            }).catch(e => {
                return undefined
            })
        }
    }

    PostApiWithFileCMS(FETCH_URL, data, nav) {
        return fetch(this.Url + FETCH_URL, {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + User.getToken()
            },
            body: data
        }).then(response => {
            if (response.status === NOT_AUTHORIZED) nav.push("/account")
            else if (response.status === OK) return response.json()
            else return response.json()
        }).catch(e => {
            return undefined
        })


    }

    DeleteApi(FETCH_URL) {
        if (User.isLoggedIn()) {
            return fetch(this.Url + FETCH_URL, {
                method: 'DELETE',
                headers: {
                    'Authorization': 'Bearer ' + User.getToken(),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'same-origin'
            })
        } else {
            return fetch(this.Url + FETCH_URL, {
                method: 'DELETE',
            }).then(response => {
                this.print("DELETE API Response (user logged in)")
                this.print(response)
                this.print("----------")

                //if (response.status === NOT_AUTHORIZED) nav.push("/account")
                return response.json()
            }).catch(e => {
                this.print('Request failed', e)
                return undefined
            })
        }
    }

    GetTableApi(FETCH_URL, handleClick) {
        let fetchUrl = FETCH_URL.includes(this.Url) ? FETCH_URL : this.Url + FETCH_URL
        return fetch(fetchUrl, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + User.getToken(),
                'Accept': 'application/json'
            }

        }).then(response => {
            //if (response.status === NOT_AUTHORIZED) nav.push("/account")
            if (response.status === OK) {
                var obj = {}
                obj.pagination = {}

                var pagi = JSON.parse(response.headers.get("X-Pagination"));
                if (pagi === null || pagi.totalCount === 0) {
                    obj.pagination.totalPages = 0
                    obj.pagination.currentPage = 0
                    obj.pagination.pageSize = 0
                    obj.pagination.totalCount = 0
                    obj.pagination.orderBy = ""
                    obj.pagination.searchQuery = ""
                    obj.data = response
                    return obj
                }
                obj.pagination.next = pagi.nextPageLink
                if (pagi.nextPageLink !== "" && pagi.nextPageLink !== null)
                    obj.pagination.nextButton = <a name="next" onClick={() => handleClick("next")} className="btn btn-default" > {">>"} </a>

                obj.pagination.prev = pagi.previousPageLink
                if (pagi.previousPageLink !== "" && pagi.previousPageLink !== null)
                    obj.pagination.prevButton = <a name="prev" onClick={() => handleClick("prev")} className="btn btn-default" > {"<<"} </a>
                obj.pagination.totalPages = pagi.totalPages
                obj.pagination.currentPage = pagi.currentPage
                obj.pagination.pageSize = pagi.pageSize
                obj.pagination.orderBy = pagi.orderBy == null ? "" : pagi.orderBy
                obj.pagination.searchQuery = pagi.searchQuery == null ? "" : pagi.searchQuery
                obj.pagination.totalCount = pagi.totalCount
                obj.data = response
                return obj
            }
            return undefined
        }).catch(e => {
            this.print('Request failed', e)
            return undefined
        })
    }

    /**
     * 
     * @param FETCH_URL -> URL  
     * @param data -> json with the form data
     * @param nav -> navigation data
     * @param handleClick -> function that will be executed when the prev/next button is pressed
     * @returns Object -> 
     *      {
     *          "pagination": 
     *          {
     *              "totalPages":"...", 
     *              "currentPage":"...", 
     *              "pageSize":"...", 
     *              "totalCount":"...",
     *              "prev":"..."},
     *              "next":"...",
     *              "prevButton":"...",
     *              "nextButton":"..."
     *          },
     *          "data":Response object
     *      }
     * It is necessary to do something like this to get data
     * (the example below gets the companies found 
     * when submitting the form of searching companies):
     * return response.data.json()
            }).then(objectData => {
                if (objectData !== undefined)
                    this.setState({ companies: objectData.companies });
            })
     */
    PostTableApi(FETCH_URL, data, nav, handleClick) {
        let fetchUrl = FETCH_URL.includes(this.Url) ? FETCH_URL : this.Url + FETCH_URL
        return fetch(fetchUrl, {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + User.getToken(),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(response => {
            if (response.status === NOT_AUTHORIZED) nav.push("/account")
            else if (response.status === OK) {
                var obj = {}
                obj.pagination = {}

                var pagi = JSON.parse(response.headers.get("X-Pagination"));
                if (pagi === null || pagi.totalCount === 0) {
                    obj.pagination.totalPages = 0
                    obj.pagination.currentPage = 0
                    obj.pagination.pageSize = 0
                    obj.pagination.totalCount = 0
                    obj.pagination.orderBy = ""
                    obj.data = response
                    this.print(obj)
                    return obj
                }
                obj.pagination.next = pagi.nextPageLink
                if (pagi.nextPageLink !== "" && pagi.nextPageLink !== null)
                    obj.pagination.nextButton = <button name="next" onClick={() => handleClick("next")} > {">>"} </button>

                obj.pagination.prev = pagi.previousPageLink
                if (pagi.previousPageLink !== "" && pagi.previousPageLink !== null)
                    obj.pagination.prevButton = <button name="prev" onClick={() => handleClick("prev")} > {"<<"} </button>
                obj.pagination.totalPages = pagi.totalPages
                obj.pagination.currentPage = pagi.currentPage
                obj.pagination.pageSize = pagi.pageSize
                obj.pagination.totalCount = pagi.totalCount
                obj.pagination.orderBy = pagi.orderBy == null ? "" : pagi.orderBy
                obj.data = response
                this.print(obj)
                return obj
            }
            return undefined
        }).catch(e => {
            this.print('Request failed', e)
            return undefined
        })
    }

    setSession(newToken, expiration, user, mail) {
        User.setToken(newToken, expiration, user, mail);
    }
    getUsername() {
        return User.getUsername();
    }
    getMail() {
        return User.getMail();
    }
    clearSession() {
        User.removeToken();
    }
    isLoggedIn() {
        return User.isLoggedIn();
    }
    setIsAdmin(isAdmin) {
        User.setIsAdmin(isAdmin)
    }
    isAdmin() {
        return User.isAdmin()
    }
    hasMemberRole() {
        return User.hasMemberRole()
    }
    hasAdminRole() {
        return User.hasAdminRole()
    }
    hasSecretaryManagementRole() {
        return User.hasSecretaryManagementRole()
    }
    hasSecretaryViewRole() {
        return User.hasSecretaryViewRole()
    }
    hasRole(role) {
        return User.hasRole(role)
    }
    setRoles(roles) {
        User.setRoles(roles)
    }
}

export default (new Api());


// WEBPACK FOOTER //
// ./src/components/Global/Modules/Api.js